<template>
    <div id="wx_welcome_template" class="card-container">
        <div class="main_center cross_center" style="margin-bottom: 15px;">
            <a-input-search placeholder="输入欢迎语" @search="onSearch" v-model="params.keywords">
                <a-button slot="enterButton">
                    查询
                </a-button>
            </a-input-search>
        </div>
        <div class="list">
            <template v-if="data && data.length > 0">
                <a-table
                    :columns="columns"
                    :data-source="data"
                    :rowKey="tableRowKey"
                    :pagination="page"
                    @change="changePagination"
                >
                    <template slot="customTitle">
                        <div class="main_between cross_center">
                            {{ title }}
                            <router-link
                                to="/welcome"
                                class="base_font_size_12 base_font_color_ff5800"
                                >添加欢迎语模板</router-link
                            >
                        </div>
                    </template>
                    <template slot="action" slot-scope="text, record">
                        <a-card hoverable :bodyStyle="{ padding: '10px' }">
                            <div class="main_between cross_center" @click="selected(record)">
                                <div
                                    class="title dir_left_wrap cross_center"
                                    style="width: 80%;"
                                    :title="text"
                                >
                                    <div class="t_omit">{{ text }}</div>
                                </div>
                                <a-icon
                                    type="check"
                                    v-if="record.isSelected"
                                    class="base_font_color_ff5800"
                                />
                            </div>
                        </a-card>
                    </template>
                </a-table>
            </template>
            <template v-else>
                <a-empty style="margin-top: 15px;">
                    <span slot="description">
                        暂无模版数据，
                        <router-link :to="{ path: '/welcome' }">立即添加欢迎语模板</router-link>
                    </span>
                </a-empty>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tableRowKey: {
            type: String,
            default: ''
        },
        tableTitle: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: function() {
                return [];
            }
        },
        page: {
            type: Object,
            default: function() {
                return {
                    total: 1,
                    pageSize: 10
                };
            }
        },
        params: {
            type: Object,
            default: function() {
                return {
                    // 渠道码欢迎语（from_qrcode），主动添加欢迎语（from_contact）
                    welcomeType: 'from_qrcode',
                    page: 1,
                    keywords: null
                };
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    // title: '欢迎语模板',
                    dataIndex: this.tableTitle,
                    slots: { title: 'customTitle' },
                    scopedSlots: { customRender: 'action' }
                }
            ]
        };
    },
    computed: {},
    mounted() {},
    watch: {},
    methods: {
        onSearch() {
            this.$emit('backWelcomeParams', this.params);
        },
        selected(data) {
            this.data.forEach((item) => {
                if (data.welcomeId === item.welcomeId) item.isSelected = true;
                else item.isSelected = false;
                return item;
            });
        },
        changePagination(e) {
            this.params.page = e.current;
            this.$emit('backWelcomeParams', this.params);
        }
    }
};
</script>

<style>
#wx_welcome_template .list {
    min-height: 300px;
}
#wx_welcome_template .ant-table-thead > tr > th .ant-table-header-column {
    width: 100%;
}
</style>
